import { useColors } from '../../hooks/useColors'

type Props = { formData: Record<string, string>; onChange: (key: string, value: string) => void }

export default function PaymentSettingsTab({ formData, onChange }: Props) {
  const colors = useColors()
  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <h3 style={{ margin: 0, color: colors.textPrimary }}>Payment Settings</h3>
      <input value={formData.delivery_fee || ''} onChange={(e) => onChange('delivery_fee', e.target.value)} placeholder="Delivery Fee" />
      <input value={formData.min_order_amount || ''} onChange={(e) => onChange('min_order_amount', e.target.value)} placeholder="Minimum Order Amount" />
      <input value={formData.free_delivery_threshold || ''} onChange={(e) => onChange('free_delivery_threshold', e.target.value)} placeholder="Free Delivery Threshold" />
      <label style={{ color: colors.textPrimary }}>
        <input type="checkbox" checked={String(formData.loyalty_enabled) === 'true'} onChange={(e) => onChange('loyalty_enabled', e.target.checked ? 'true' : 'false')} /> Loyalty Enabled
      </label>
    </div>
  )
}
